(() => {
    console.log("COC COL HERO JS LOADED");

  const SELECTOR = '[data-coc-col-hero]';

  const DEFAULTS = {
    interval: 4500,
    pauseOnHover: true,
    swipeThreshold: 45,
    loop: true
  };

  const qs = (el, sel) => el.querySelector(sel);
  const qsa = (el, sel) => Array.from(el.querySelectorAll(sel));
  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  function buildDots(root, count){
    const wrap = qs(root, '.coc-col-hero__dots');
    if (!wrap) return null;
    wrap.innerHTML = '';
    const dots = [];
    for (let i=0;i<count;i++){
      const d = document.createElement('span');
      d.className = 'coc-col-hero__dot' + (i===0 ? ' is-active' : '');
      d.setAttribute('data-dot-idx', String(i));
      wrap.appendChild(d);
      dots.push(d);
    }
    return dots;
  }

  function setActiveDot(dots, idx){
    if (!dots) return;
    dots.forEach((d,i) => d.classList.toggle('is-active', i === idx));
  }

  function createController(root){
    const viewport = qs(root, '.coc-col-hero__viewport');
    const track = qs(root, '.coc-col-hero__track');
    const slides = qsa(root, '.coc-col-hero__slide');
    if (!viewport || !track || slides.length < 2) return;

    const btnPrev = qs(root, '.coc-col-hero__arrow.is-prev');
    const btnNext = qs(root, '.coc-col-hero__arrow.is-next');

    const opts = {
      ...DEFAULTS,
      interval: Number(root.getAttribute('data-interval')) || DEFAULTS.interval
    };

    let index = 0;
    let timer = null;

    const dots = buildDots(root, slides.length);

    const getW = () => Math.max(1, viewport.getBoundingClientRect().width || 1);

    function setX(px){
      track.style.transform = `translate3d(${-px}px,0,0)`;
    }

    function go(to, {fromUser=false} = {}){
      const prev = index;

      if (!opts.loop){
        index = clamp(to, 0, slides.length - 1);
      }else{
        index = (to + slides.length) % slides.length;
      }

      if (prev === index && fromUser) return;

      const w = getW();
      setX(index * w);
      setActiveDot(dots, index);

      if (!opts.loop){
        if (btnPrev) btnPrev.disabled = (index === 0);
        if (btnNext) btnNext.disabled = (index === slides.length - 1);
      }
    }

    const next = (fromUser=false) => { go(index + 1, {fromUser}); };
    const prev = (fromUser=false) => { go(index - 1, {fromUser}); };

    function stop(){
      if (timer) clearInterval(timer);
      timer = null;
    }
    function start(){
      stop();
      timer = setInterval(() => next(false), opts.interval);
    }

    if (btnNext) btnNext.addEventListener('click', () => { next(true); start(); });
    if (btnPrev) btnPrev.addEventListener('click', () => { prev(true); start(); });

    const dotsWrap = qs(root, '.coc-col-hero__dots');
    if (dotsWrap){
      dotsWrap.addEventListener('click', (e) => {
        const t = e.target;
        if (!(t instanceof HTMLElement)) return;
        const v = t.getAttribute('data-dot-idx');
        if (v == null) return;
        go(parseInt(v, 10), {fromUser:true});
        start();
      });
    }

    if (opts.pauseOnHover){
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
    }

    // swipe / drag
    let isDown = false;
    let startX = 0;
    let deltaX = 0;

    function onDown(clientX){
      isDown = true;
      startX = clientX;
      deltaX = 0;
      track.style.transition = 'none';
      stop();
    }

    function onMove(clientX){
      if (!isDown) return;
      deltaX = clientX - startX;
      const w = getW();
      setX(index * w - deltaX);
    }

    function onUp(){
      if (!isDown) return;
      isDown = false;
      track.style.transition = ''; // CSSに戻す

      if (Math.abs(deltaX) >= opts.swipeThreshold){
        if (deltaX < 0) next(true);
        else prev(true);
      }else{
        go(index);
      }
      start();
    }

    root.addEventListener('touchstart', (e) => {
      if (!e.touches || !e.touches.length) return;
      onDown(e.touches[0].clientX);
    }, {passive:true});

    root.addEventListener('touchmove', (e) => {
      if (!e.touches || !e.touches.length) return;
      onMove(e.touches[0].clientX);
    }, {passive:true});

    root.addEventListener('touchend', onUp);

    root.addEventListener('mousedown', (e) => onDown(e.clientX));
    window.addEventListener('mousemove', (e) => onMove(e.clientX));
    window.addEventListener('mouseup', onUp);

    // resize対応（幅が変わったら位置を合わせ直す）
    window.addEventListener('resize', () => go(index));

    // init
    go(0);
    start();
  }

  function boot(){
    document.querySelectorAll(SELECTOR).forEach(createController);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  }else{
    boot();
  }
})();
